import { BoundControl } from 'ui/components/BoundControl';

export default class AutoValidationDisplay extends BoundControl {
  render() {
    return this.renderValidation();
  }
}
